import { createSlice } from '@reduxjs/toolkit';

export const commentSlice = createSlice({
    name: 'comment',
    initialState: {
        data: [],
        loading: true,
    },
    reducers: {
        comment: (state, action) => {
            console.log("data + loading: false")
            state.data = action.payload
            state.loading = false
        },
        loadingComment: (state) => {
            console.log("loading: true")
            state.loading = true
        }

    },
});

export const { comment, loadingComment} = commentSlice.actions;

export const commentData = state => state.commentdata;


export default commentSlice.reducer;
